import React from "react";
import styled from "styled-components";
import {device} from "../../assets/styles/media";

const Container = styled.p`
    position: relative;
    font-size: 18px;
    white-space: initial;
    &::after {
        content: "";
        position: absolute;
        top: 10px;
        left: -12px;
        width: 4px;
        height: 4px;
        border-radius: 100%;
        background: #362579;
    }

    strong {
        font-size: 18px;
        font-weight: 600;
    }

    ${device.tablet} {
        font-size: 16px;
    
    }

    ${device.mobile} {
        span,
        strong {
            font-size: 14px;
        }

        font-size: 14px;
        font-weight: 400;
        line-height: 22px;

        &::after {
            top: 8px;
            left: -12px;
            width: 3px;
            height: 3px;
        }
    }
`;

const Bullet = ({children}) => {
    return (
        <Container>{children}</Container>
    );
};

export default Bullet;
